// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerPage-cls1_TAP","cls2":"VideoPlayerPage-cls2_h3G VideoPlayerPage-cls1_TAP"};